import React, {useState} from 'react';
import {Col, Container, Dropdown, Row} from 'react-bootstrap';
import {AppNavbar} from '../components/AppNavbar';
import {PLAN, SKUTECNOST, SOUHRN, STATISTIKA, STROM} from '../enums/PohledTypeEnum';
import {StromPanel} from '../components/StromPanel';
import {RouteComponentProps, useHistory} from 'react-router';
import {Footer} from '../components/Footer';

type Props = RouteComponentProps<{id: string; idVerze: string}, {}>;
export const StromPage: React.FC<Props> = ({match: {params}}) => {
    const [pohledType, setPohledType] = useState(PLAN);

    const history = useHistory();

    return (
        <div className="main-div">
            <header>
                <AppNavbar page={'strom'} idVerze={params.idVerze} idStrom={params.id} planObdobi={pohledType} />
            </header>
            <main>
                <Container fluid>
                    <Row xs="auto" style={{paddingTop: 10, paddingBottom: 10, height: '100%'}}>
                        <Col>
                            <Dropdown>
                                <Dropdown.Toggle variant="light" id="dropdown-basic">
                                    {STROM}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => history.push('/souhrn/' + params.idVerze)}>{SOUHRN}</Dropdown.Item>
                                    <Dropdown.Item>{STROM}</Dropdown.Item>
                                    <Dropdown.Item onClick={() => history.push('/statistika/' + params.idVerze)}>{STATISTIKA}</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                        <Col>
                            <Dropdown>
                                <Dropdown.Toggle variant="light" id="dropdown-basic">
                                    {pohledType}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => setPohledType(PLAN)}>{PLAN}</Dropdown.Item>
                                    <Dropdown.Item onClick={() => setPohledType(SKUTECNOST)}>{SKUTECNOST}</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                    </Row>
                    <Row>
                        <StromPanel skutecnost={pohledType === SKUTECNOST} idPlan={params.id} idVerze={params.idVerze} />
                    </Row>
                </Container>
            </main>
            <footer>
                <Footer idPlanVerze={params.idVerze} />
            </footer>
        </div>
    );
};
